import { createContext, useContext } from 'react';
import type { Values } from './types';

/**
 * The whole asset being shown or edited, for fields nested deep inside it that depend on the root:
 * reward.alwaysGiven only applies when the quest's rewardIsChoice is on; a dialogue choice's target is
 * one of the dialogue's pages.
 */
export const RootValues = createContext<Values | null>(null);

export function useRootValues(): Values | null {
  return useContext(RootValues);
}

/**
 * Asks before moving or deleting quest steps or objectives, whose positions player saves keep progress by
 * (see progress.ts); returns whether to go ahead. The record editor asks once, and only for a quest in Unity.
 */
export const ConfirmProgressMove = createContext<() => boolean>(() => true);

export function useConfirmProgressMove(): () => boolean {
  return useContext(ConfirmProgressMove);
}
